import {
    AccountProvisionTriggerSubSource,
    CompanyAccountProvisioningProductType,
    RoleType
} from '../constants-types/Enums';
import { ITranslationService } from '../system-interface/ITranslationService.interface';
import { ResultBasics } from './ResultBasics.model';

export const UnknownUserId = 'unknown';

export class UserStub {
    private static unknownUser: UserStub;

    readonly firstName: string;
    readonly lastName: string;
    readonly email: string;
    readonly id: string;

    constructor(
        private TR: ITranslationService,
        obj?: Partial<UserStub>
    ) {
        Object.assign(this, obj);
    }

    getFullName(): string {
        return this.isUnknown()
            ? this.TR.key('display.unknownUser')
            : `${this.lastName}, ${this.firstName}`;
    }

    getFullDisplayName(): string {
        let string = `${this.firstName} ${this.lastName}`;
        if (this.email) {
            string += ` (${this.email})`;
        }
        return string;
    }

    getPartialDisplayName() {
        if (this.firstName || this.lastName) {
            return `${this.firstName} ${this.lastName}`.trim();
        } else {
            return this.email;
        }
    }

    isUnknown(): boolean {
        return this.id === UnknownUserId;
    }
}
export class UserStubWithState extends UserStub {
    stateInvalid: boolean;
}

export class User extends UserStub implements ResultBasics {
    readonly middleName?: string;
    readonly jobTitle: string;
    readonly phone?: string;
    readonly defaultLanguage?: string;
    readonly defaultFolderId?: string;
    readonly role?: RoleType;
    readonly lastLoginTime?: Date;
    readonly hasCognitiveAccess: boolean = false;
    readonly accessEnabled: boolean = false;
    readonly isThirdPartyUser: boolean = false;
    readonly personId?: string;

    constructor(TR: ITranslationService, obj?: Partial<User>) {
        super(TR, obj);
        Object.assign(this, obj);
    }
}

export class UserUpdate implements ResultBasics {
    firstName: string;
    middleName?: string;
    lastName: string;
    email?: string;
    jobTitle?: string;
    phone?: string;
    defaultLanguage?: string;
    defaultFolderId?: string;
    role?: RoleType;
    lastLoginTime?: Date;
    hasCognitiveAccess = false;
    accessEnabled = false;
    isThirdPartyUser = false;
    id: string;
    teamId?: string;
    accountProvisionTriggerSubsource: AccountProvisionTriggerSubSource =
        AccountProvisionTriggerSubSource.PISoftware;
    product: CompanyAccountProvisioningProductType;

    getFullName(): string {
        return `${this.lastName}, ${this.firstName}`;
    }

    originalUser: User;

    constructor(user: Partial<UserUpdate>, original: User | null = null) {
        if (original) {
            this.originalUser = original;
        }
        Object.assign(this, user);
    }
}
